<template>
	<app-content class="h-panel">
		<Loading text="数据加载中..." :loading="loading"></Loading>
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="report">{{report.name}}</template>&nbsp;</span>
			<Button class="float-right" @click="$router.back()">返回</Button>
		</div>
		<div class="margin-top margin-left margin-right">
			<account-date-choose v-if="!quarterMode" v-model="accountDate"/>
			<span v-else class="quarter-picker">
				<DatePicker v-model="quarter.year" type="year" format="yyyy" style="width:110px"></DatePicker>
				<Select v-model="quarter.no" style="width:120px">
					<Option :value="1">第一季度</Option>
					<Option :value="2">第二季度</Option>
					<Option :value="3">第三季度</Option>
					<Option :value="4">第四季度</Option>
				</Select>
			</span>
			<Button size="small" class="margin-left" @click="toggleMode">
				{{ quarterMode ? '切换到月报' : '切换到季报' }}
			</Button>
			<Button size="small" class="margin-left" v-if="report.type === 3" @click="exportEquity">导出</Button>
			<router-link tag="button" class="h-btn float-right" v-if="User.role!=='View' && report.type !== 3" :to="{name:'TemplateForm',params:{templateId:reportId}}">编辑数据项</router-link>
		</div>
		<div class="h-panel-body">
			<Table class="small-td" :datas="templateItems" selectRow border v-if="report.type==0 || report.type==100">
				<TableItem title="名称">
					<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
					</template>
				</TableItem>
				<TableItem title="本年累计金额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem title="本期金额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
					</template>
				</TableItem>
			</Table>
			<Table :datas="templateItemsRender" selectRow border v-else-if="report.type == 1">
				<TableItem title="资产">
					<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
					</template>
				</TableItem>
				<TableItem title="期末余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem title="年初余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem :title="rightTitle">
					<div slot-scope="{data}" :class="{'font-bold':data.fs_isBolder}" :style="{paddingLeft:((data.fs_level-1)*15)+'px'}">{{data.fs_title}}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{data.fs_isClassified ? '':data.fs_lineNum>-1?data.fs_lineNum:''}}
					</template>
				</TableItem>
				<TableItem title="期末余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.fs_id]?reportData[data.fs_id].currentPeriodAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem title="年初余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.fs_id]?reportData[data.fs_id].currentYearAmount:''|numFormat}}
					</template>
				</TableItem>
			</Table>
			<table class="equity-table" v-else-if="report.type == 3">
				<thead>
				<tr>
					<th class="equity-title">项目</th>
					<th v-for="col in equityColumns" :key="col">{{col}}</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="row in equityRows" :key="row.lineNum">
					<td class="equity-title" :class="{'font-bold':row.isBolder}">{{row.title}}</td>
					<td v-for="(cellId, idx) in row.cells" :key="idx" align="right">
						{{reportData[cellId] ? reportData[cellId].currentPeriodAmount : ''|numFormat}}
					</td>
				</tr>
				</tbody>
			</table>
				<div class="report-notes" v-if="reportNotes.length">
					<div class="report-notes-title">附注说明</div>
					<p v-for="(note, idx) in reportNotes" :key="idx">{{note}}</p>
				</div>
			</div>
		</app-content>
	</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: "ReportView.vue",
		props: {
			reportId: [Number, String]
		},
		data() {
			let now = new Date();
			return {
				report: {},
				reportData: {},
				accountDate: null,
				loading: false,
				quarterMode: false,
				quarter: {
					year: now.getFullYear(),
					no: Math.floor(now.getMonth() / 3) + 1
				}
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets']),
			/**
			 * 资产负债表右侧标题：民非、工会、政府会计为“负债和净资产”，其余为“负债和所有者权益”
			 */
			rightTitle() {
				let standard = this.currentAccountSets ? Number(this.currentAccountSets.accountingStandards) : null;
				return [2, 6, 7].indexOf(standard) >= 0 ? '负债和净资产' : '负债和所有者权益';
			},
			templateItems() {
				return this.report ? this.report.items : [];
			},
			templateItemsRender() {
				if (this.report.type === 1) {
					//所有资产
					let zc = this.templateItems.filter(val => val.type === 0);
					let sq = this.templateItems.filter(val => val.type !== 0);
					sq.forEach((val, index) => {
						let changeObj = {
							fs_id: val.id,
							fs_lineNum: val.lineNum,
							fs_isBolder: val.isBolder,
							fs_level: val.level,
							fs_isClassified: val.isClassified,
							fs_title: val.title
						};
						//负债/权益行数多于资产行数时，补齐左侧空行，避免右侧合计行被截断
						if (!zc[index]) {
							zc.push({id: null, title: '', lineNum: null, level: 1, isBolder: false, isClassified: true, type: 0});
						}
						Object.assign(zc[index], changeObj);
					});
					return zc;
				}
				return [];
			},
			/**
			 * 矩阵报表列：type 为列索引，-1 为项目列，最后一列为合计
			 * 企业会计准则：所有者权益变动表 9 列；政府会计：净资产变动表 4 列，预算结转结余变动表 1 列；
			 * 民非：净资产变动表 3 列；合作社：成员权益变动表 6 列；工会：财政拨款收入支出表、国有资产情况表各 4 列
			 */
			equityColumns() {
				let standard = this.currentAccountSets ? Number(this.currentAccountSets.accountingStandards) : null;
				let name = this.report ? this.report.name : '';
				if (standard === 7) {
					return name === '净资产变动表'
						? ['累计盈余', '专用基金', '权益法调整', '净资产合计']
						: ['金额'];
				}
				if (standard === 2 && name === '净资产变动表') {
					return ['非限定性净资产', '限定性净资产', '净资产合计'];
				}
				if (standard === 5 && name === '成员权益变动表') {
					return ['股金', '专项基金', '资本公积', '盈余公积', '未分配盈余', '成员权益合计'];
				}
				if (standard === 6) {
					if (name === '财政拨款收入支出表') {
						return ['年初结转结余', '本年收入', '本年支出', '年末结转结余'];
					}
					if (name === '国有资产情况表') {
						return ['年初数', '本年增加', '本年减少', '年末数'];
					}
				}
				return ['实收资本（或股本）', '其他权益工具', '资本公积', '减：库存股', '其他综合收益', '专项储备', '盈余公积', '未分配利润', '所有者权益合计'];
			},
			/**
			 * 报表附注说明：民非净资产变动表编制说明
			 */
			reportNotes() {
				if (this.report && this.report.templateKey === 'jzbd') {
					return [
						'1. 本表反映民间非营利组织一定会计期间内净资产的构成及增减变动情况。',
						'2. “非限定性净资产”栏根据“非限定性净资产”（3101）科目填列；“限定性净资产”栏根据“限定性净资产”（3102）科目填列；“净资产合计”栏为前两栏之和。',
						'3. “年初余额”根据上年末净资产余额填列；“本年增加额”“本年减少额”分别根据净资产科目本年贷方、借方发生额填列；“年末余额”＝年初余额＋本年增加额－本年减少额。',
						'4. 限定性净资产解除限制转入非限定性净资产时，限定性净资产减少、非限定性净资产等额增加，净资产合计不变。',
						'5. 本表为建议编制报表，不替代法定的资产负债表、业务活动表和现金流量表。'
					];
				}
				return [];
			},
			equityRows() {
				if (!this.report || this.report.type !== 3) {
					return [];
				}
				let rows = {};
				(this.templateItems || []).forEach(item => {
					if (item.lineNum === null || item.lineNum === undefined || item.lineNum < 1) {
						return;
					}
					if (!rows[item.lineNum]) {
						rows[item.lineNum] = {lineNum: item.lineNum, title: '', isBolder: false, cells: []};
					}
					let row = rows[item.lineNum];
					if (item.type === -1) {
						row.title = item.title;
						row.isBolder = item.isBolder;
					} else if (item.type >= 0 && item.type <= 8) {
						row.cells[item.type] = item.id;
					}
				});
				return Object.keys(rows).map(key => rows[key]).sort((a, b) => a.lineNum - b.lineNum);
			}
		},
		watch: {
			accountDate() {
				this.loadReportData();
			},
			reportId() {
				this.loadReport();
			},
			quarter: {
				deep: true,
				handler() {
					if (this.quarterMode) {
						this.loadReportData();
					}
				}
			}
		},
		created() {
			//季报直达
			if (this.$route.meta && this.$route.meta.quarter) {
				this.quarterMode = true;
			}
			if (this.reportId) {
				this.loadReport();
			} else if (this.$route.meta && this.$route.meta.symbol) {
				this.resolveSymbol(this.$route.meta.symbol);
			}
		},
		methods: {
			/**
			 * 通过模板标识（lrb/xjllb）解析出当前账套的模板ID并加载
			 */
			resolveSymbol(symbol) {
				Api.report.template.list().then(({data}) => {
					let arr = data.records || data || [];
					let t = arr.find(x => x.templateKey === symbol);
					if (t) {
						this.loadReport(t.id);
					} else {
						this.$Message.warning('未找到对应报表模板，请先在系统报表中初始化');
					}
				});
			},
			toggleMode() {
				this.quarterMode = !this.quarterMode;
				this.loadReportData();
			},
			/**
			 * 导出矩阵报表（所有者权益变动表/净资产变动表/预算结转结余变动表）为 CSV
			 */
			exportEquity() {
				let rows = this.equityRows;
				if (!rows.length) {
					this.$Message.warning('暂无可导出的数据');
					return;
				}
				let fmt = v => (v === null || v === undefined || v === '') ? '' : Number(v).toFixed(2);
				let cellVal = id => {
					let d = this.reportData[id];
					return d ? fmt(d.currentPeriodAmount) : '';
				};
				let esc = s => `"${String(s == null ? '' : s).replace(/"/g, '""')}"`;
				let lines = [];
				lines.push([esc(this.report.name)].join(','));
				lines.push(['项目', ...this.equityColumns].map(esc).join(','));
				for (let row of rows) {
					let cells = this.equityColumns.map((_, idx) => row.cells[idx] != null ? cellVal(row.cells[idx]) : '');
					lines.push([esc(row.title), ...cells].join(','));
				}
				//附注说明随报表一并导出
				if (this.reportNotes.length) {
					lines.push('');
					lines.push(esc('附注说明'));
					for (let note of this.reportNotes) {
						lines.push(esc(note));
					}
				}
				let blob = new Blob(['﻿' + lines.join('\r\n')], {type: 'text/csv;charset=utf-8'});
				let link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = `${this.report.name}.csv`;
				link.click();
				URL.revokeObjectURL(link.href);
			},
			quarterEndDate() {
				let end = new Date(this.quarter.year, this.quarter.no * 3, 0);
				let fmt = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
				return fmt(end);
			},
			loadReport(rid) {
				let id = rid || this.reportId;
				if (!id) {
					return;
				}
				Api.report.template.load(id).then(({data}) => {
					this.report = data;
					this.$nextTick(this.loadReportData);
				});
			},
			loadReportData() {
				if (!this.report.id) {
					return;
				}
				this.loading = true;
				let request;
				if (this.quarterMode) {
					//季报入口按模板标识解析而来，reportId 可能为空，统一取已加载报表的 id
					request = Api.report.viewQuarter(this.report.id, {accountDate: this.quarterEndDate()});
				} else {
					request = Api.report.view(this.report.id, {accountDate: this.accountDate});
				}
				request.then(({data}) => {
					this.reportData = data;
				}).finally(() => this.loading = false);
			}
		}
	}
</script>

<style scoped>
	div.font-bold {
		font-size: 14px;
	}
	.quarter-picker {
		display: inline-flex;
		align-items: center;
	}
	.equity-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 13px;
	}
	.equity-table th,
	.equity-table td {
		border: 1px solid #e0e0e0;
		padding: 6px 8px;
		text-align: center;
	}
	.equity-table th {
		background: #f7f7f7;
		font-weight: 600;
	}
	.equity-table .equity-title {
		text-align: left;
		min-width: 220px;
	}
	.report-notes {
		margin-top: 12px;
		font-size: 12px;
		color: #666;
		line-height: 1.8;
	}
	.report-notes-title {
		font-weight: 600;
		margin-bottom: 4px;
	}
</style>